import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5 22.9154C18.253 22.9154 22.9167 18.2517 22.9167 12.4987C22.9167 6.74573 18.253 2.08203 12.5 2.08203C6.74707 2.08203 2.08337 6.74573 2.08337 12.4987C2.08337 18.2517 6.74707 22.9154 12.5 22.9154Z",
      stroke: "#FF0000",
      "stroke-width": "2.08333",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.4461 9.55469L9.55359 15.4472",
      stroke: "#FF0000",
      "stroke-width": "2.08333",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.55383 9.55469L15.4464 15.4472",
      stroke: "#FF0000",
      "stroke-width": "2.08333",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }